module.exports = __webpack_public_path__ + "img/IMG_2614_T_L_Wood_MockedUp.523f470a.jpg";